angular.module('eStories.affiliatesProgram.model', [])

    .service('AffiliatesProgramModel', [
        '$location',
        '$cookies',
        '$http',
        'AccountModel',
        function ($location,
                  $cookies,
                  $http,
                  AccountModel) {
            var model = this;

            model.storeUtmPackageCookie = function (expiresInDays) {
                if (!$location.search()['utm_source']) {
                    return;
                }

                var utmPackage = {};
                utmPackage["ref"] = $location.search()['ref'];
                utmPackage["utmSource"] = $location.search()['utm_source'];
                utmPackage["utmCampaign"] = $location.search()['utm_campaign'];
                utmPackage["utmMedium"] = $location.search()['utm_medium'];
                utmPackage["utmAffiliateTransId"] = $location.search()['utm_affiliateTransId'];

                let expirationDate = new Date();
                expirationDate.setDate(expirationDate.getDate() + expiresInDays);
                $cookies.put('ES_UTM_PACKAGE', JSON.stringify(utmPackage), {expires: expirationDate});

            };

            model.getAllUTMParams = function () {
                let utmParamsObj = $cookies.get('ES_UTM_PACKAGE');
                return utmParamsObj ? JSON.parse(utmParamsObj) : null;
            };

            model.getUtmRequestObj = function () {
                if (!model.getAllUTMParams()){
                    return null;
                }
                var utmObj = model.getAllUTMParams();

                return {
                    utmCampaign: utmObj.utmCampaign,
                    utmMedium: utmObj.utmMedium,
                    utmSource: utmObj.utmSource,
                    utmAffiliateTransactionId: utmObj.utmAffiliateTransId
                }
            };

            model.removeAffiliateCookies = function () {
                $cookies.remove('ES_UTM_PACKAGE');
            };

            model.setPlanBoughtWithPromoFlag = function (amount) {
                model.boughtPlanWithUtm = true;
                model.amountBought = amount;
            };

            model.getAffiliatePixel = function () {

                if (!model.boughtPlanWithUtm || !model.getUtmRequestObj() || !model.amountBought) return;
                var utmObj = model.getAllUTMParams();
                var ref = utmObj.ref;
                var affiliateCampaign = utmObj.utmCampaign;
                    if (ref === 'mp') {
                        switch (affiliateCampaign) {
                            case 'RBmyp_50offAnnBasic':
                                return "<!-- Offer Goal Conversion: eStories 50% off basic annual plan mp -->" +
                                    "<iframe src='https://sboffers.swagbucks.com/GL3nh' scrolling='no' frameborder='0' width='1' height='1'></iframe>" +
                                    "<!-- // End Offer Goal Conversion -->";
                                break;
                            case 'RBmyp_50off3months':
                                return "<!-- Offer Goal Conversion: eStories 50% off 3 months mp -->" +
                                    "<iframe src='https://sboffers.swagbucks.com/GL3nb' scrolling='no' frameborder='0' width='1' height='1'></iframe>" +
                                    "<!-- // End Offer Goal Conversion -->";
                                break;
                            case 'MYP_BOGOX2':
                                return "<!-- Offer Goal Conversion: eStories Buy 1 Get 2 Off(id: 28700) -->" +
                                    "<iframe src='https://sboffers.swagbucks.com/GL3np' scrolling='no' frameborder='0' width='1' height='1'></iframe>" +
                                    "<!-- // End Offer Goal Conversion -->";
                                break;
                            case 'RBmyp_B1G2':

                                break;
                            default :
                                break;
                        }
                    } else if (ref === 'sb') {
                        switch (affiliateCampaign) {
                            case 'RBSW_50offAnnBasic':
                                return "<!-- Offer Goal Conversion: eStories 50% off basic annual plan sb -->" +
                                    "<iframe src='https://sboffers.swagbucks.com/GL3nf' scrolling='no' frameborder='0' width='1' height='1'></iframe>" +
                                    "<!-- // End Offer Goal Conversion -->";
                                break;
                            case 'RBSW_50off3months':
                                return "<!-- Offer Goal Conversion: eStories 50% off 3 months sb -->" +
                                    "<iframe src='https://sboffers.swagbucks.com/GL3nd' scrolling='no' frameborder='0' width='1' height='1'></iframe>" +
                                    "<!-- // End Offer Goal Conversion -->";
                                break;
                            case 'SW_BOGOX2':
                                return "<!-- Offer Goal Conversion: eStories Buy 1 Get 2 Off(id: 29289) -->" +
                                    "<iframe src='https://sboffers.swagbucks.com/GL3nl' scrolling='no' frameborder='0' width='1' height='1'></iframe>" +
                                    "<!-- // End Offer Goal Conversion -->";
                                break;
                            default :
                                break;
                        }

                    } else if (ref === 'sd') {
                        var campaignId = -1;
                        switch (affiliateCampaign) {
                            case 'SDRB50offAnnual':
                                campaignId = 12639;
                                break;
                            case 'slick_2cdt_30daytrial':
                                campaignId = 13670;
                                break;
                        }

                        ire('trackConversion', campaignId, {
                                customerId: AccountModel.userDetails.snid,
                                orderId: AccountModel.subscriptionDetails.subscription.id,
                                currencyCode: AccountModel.subscriptionDetails.subscription.currency,
                                items: [
                                    {
                                        subTotal: AccountModel.subscriptionDetails.subscription.price,
                                        category: "audiobooks",
                                        sku: affiliateCampaign,
                                        quantity: 1
                                    }
                                ]
                            }
                        );
                    }
                    model.removeAffiliateCookies();
            };

        }]);
